<div class="flex flex-col items-center">
  @if (success()) {
      <fa-icon [icon]="icons.faCircleCheck" class="w-[100px] h-[100px] text-custom-blue mb-8 text-[100px]"></fa-icon>
      <h1 class="text-[30px] mb-2">Your password has been reset</h1>
      <p class="text-[20px] text-custom-blue-head mb-8">
        All set! Your password was successfully reset and you're now signed in.
      </p>
  } @else {
      <fa-icon [icon]="icons.faCircleExclamation" class="w-[100px] h-[100px] text-custom-blue mb-8 text-[100px]"></fa-icon>
      <h1 class="text-[30px] mb-2">We couldn't reset your password</h1>
      <p class="text-[20px] text-[#4A4A4A] mb-8">
        Something went wrong. Please try again.
      </p>
  }
  <button pButton (click)="closeModal()" class="lg:w-[535px] w-4/5 bg-custom-blue text-white h-[35px] text-[16px] rounded-[18px]">Close</button>
</div>